"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpSectionCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_bootstrap_1 = require("react-bootstrap");
var DpSectionCard_styled_1 = require("./DpSectionCard.styled");
var DpSectionCard = function (_a) {
    var title = _a.title, toolbar = _a.toolbar, children = _a.children;
    return ((0, jsx_runtime_1.jsx)(DpSectionCard_styled_1.StyledSectionCard, { children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Card, { as: "section", children: [(0, jsx_runtime_1.jsxs)(react_bootstrap_1.Card.Header, { children: [typeof title === 'string' ? (0, jsx_runtime_1.jsx)("h1", { className: "h4", children: title }) : title, toolbar] }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Card.Body, { children: children })] }) }));
};
exports.DpSectionCard = DpSectionCard;
exports.default = exports.DpSectionCard;
